import React, { useState, useEffect } from 'react'
import './Loading.css'

const Loading = ({
    message = 'Đang tải dữ liệu...',
    show = true,
    showProgress = true // Hiển thị progress bar
}) => {
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        if (!show) {
            setProgress(0)
            return
        }

        // Simulate progress
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 95) return prev
                const increment = Math.random() * 15
                return Math.min(prev + increment, 95)
            })
        }, 500)

        return () => clearInterval(interval)
    }, [show])

    // Auto complete when unmounting
    useEffect(() => {
        if (!show && progress > 0) {
            setProgress(100)
        }
    }, [show, progress])

    if (!show) return null

    return (
        <div className="delytour-loading-overlay">
            <div className="delytour-loading-modal">
                {/* Brand Logo */}
                <div className="delytour-brand">
                    <h2 className="delytour-logo">Delytour</h2>
                    <div className="delytour-tagline">Your Journey, Our Passion</div>
                </div>

                {/* Airplane animation */}
                <div className="delytour-airplane-container">
                    <svg className="delytour-airplane" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <path
                                fill="#3B82F6"
                                d="M472 176h-64l-64-96h-48l32 96h-96l-32-32h-32l16 64-16 64h32l32-32h96l-32 96h48l64-96h64c22.091 0 40-17.909 40-40s-17.909-40-40-40z"
                            />
                            <circle fill="#E0F2FE" cx="280" cy="176" r="8" />
                            <circle fill="#E0F2FE" cx="304" cy="176" r="8" />
                            <circle fill="#E0F2FE" cx="328" cy="176" r="8" />
                        </g>
                    </svg>
                    <div className="delytour-airplane-trail"></div>
                </div>

                {/* Loading message */}
                <div className="delytour-message">
                    <p>{message}</p>
                    <div className="delytour-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                {/* Progress bar */}
                {showProgress && (
                    <div className="delytour-progress-container">
                        <div className="delytour-progress-bar">
                            <div
                                className="delytour-progress-fill"
                                style={{ width: `${progress}%` }}
                            ></div>
                        </div>
                        <div className="delytour-progress-text">{Math.round(progress)}%</div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Loading
